import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const OAuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [message, setMessage] = useState('Processing authorization...');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      setStatus('error');
      setMessage(`Authorization failed: ${error}`);
      return;
    }

    if (code && state) {
      // Send message to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'oauth_callback',
          code: code,
          state: state
        }, '*');
        
        setStatus('success');
        setMessage('Authorization successful! You can close this window.');
        
        // Auto-close after 2 seconds
        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        setStatus('error');
        setMessage('Could not communicate with parent window. Please close this window and try again.');
      }
    } else {
      setStatus('error');
      setMessage('Invalid callback parameters');
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6 text-center">
          {status === 'processing' && (
            <>
              <Loader2 className="h-12 w-12 mx-auto mb-4 text-blue-500 animate-spin" />
              <h2 className="text-lg font-semibold">Processing</h2>
              <p className="text-muted-foreground mt-2">{message}</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <CheckCircle2 className="h-12 w-12 mx-auto mb-4 text-green-500" />
              <h2 className="text-lg font-semibold text-green-700">Success!</h2>
              <p className="text-muted-foreground mt-2">{message}</p>
            </>
          )}
          
          {status === 'error' && (
            <>
              <XCircle className="h-12 w-12 mx-auto mb-4 text-red-500" />
              <h2 className="text-lg font-semibold text-red-700">Error</h2>
              <p className="text-muted-foreground mt-2">{message}</p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default OAuthCallbackPage;
